module.exports = __webpack_public_path__ + "static/inventorsprint-37a5a6b448c6fe522c279d8f8852635f.jpg";